import { Controller } from "@hotwired/stimulus"
import Turbolinks from "turbolinks"

export default class extends Controller {
  open(event) {
    if (event.target.closest("a, button, form")) return

    Turbolinks.visit(event.params.url)
  }
}
